export default function getCampaignTypeClass(campaignType) {
    return {
        'bg-light': campaignType === 'CAMPAIGN_REGULAR',
        'bg-cyan text-dark': campaignType === 'CAMPAIGN_AUTOMATED_EVENT_BASED',
        'bg-indigo': campaignType === 'CAMPAIGN_MBOX'
    }
}